import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table } from 'react-bootstrap';
import Navigator from 'Components/Shared/Navigator';
import {
    AiOutlinePlusCircle,
    AiOutlineCheckCircle,
    AiOutlineCloseCircle,
    AiOutlineEdit,
    AiOutlineUserAdd,
} from 'react-icons/ai';

import EventService from 'Services/EventService';

const EventsIndex = () => {
    const [events, setEvents] = useState([]);

    useEffect(() => {
        EventService.getEvents()
            .then((result) => {
                if (result.status === 200) {
                    setEvents(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Navigator section="Events"></Navigator>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Events</h2>
                <Link to="/admin/event/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Handle</th>
                        <th>Description</th>
                        <th className="text-center">Supervisor</th>
                        <th className="text-center">Subscribers</th>
                        <th className="text-center">Edit</th>
                        <th className="text-center">Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {events.length ? (
                        events.map((event, key) => {
                            return (
                                <tr key={key}>
                                    <td>{event.handle}</td>
                                    <td>{event.description}</td>
                                    <td className="text-center">
                                        {event.notifyOriginSupervisor ? (
                                            <AiOutlineCheckCircle
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        ) : (
                                            <AiOutlineCloseCircle
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        )}
                                    </td>
                                    <td className="text-center">
                                        <Link to={`/admin/event/subscribers/${event.eventId}`}>
                                            <AiOutlineUserAdd
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td className="text-center">
                                        <Link to={`/admin/event/edit/${event.eventId}`}>
                                            <AiOutlineEdit
                                                style={{
                                                    fontSize: '16pt',
                                                    color: 'black',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td className="text-center">
                                        <Link to={`/admin/event/delete/${event.eventId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default EventsIndex;
